module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gbhhV"))).then(() => parcelRequire('f4eak'));